import { gql } from "@apollo/client";
import { ACFMediaFragment } from "./ACF/Media";
import { PageDataFragment } from "./PageData";

export const BaseInducteeInfoFragment = gql`
  ${ACFMediaFragment}
  ${PageDataFragment}
  fragment BaseInducteeInfo on Inductee {
    uri
    title
    ...PageData
    inducteeData {
      category
      sortName
      inducteeClass {
        slug
      }
    }
  }
`;

export const InducteeLandingInfoFragment = gql`
  ${ACFMediaFragment}
  fragment InducteeLandingInfo on Inductee {
    uri
    title
    pageData {
      featuredImage {
        ...ACFMedia
      }
    }
    inducteeLandingMembers {
      name
    }
    inducteeData {
      category
      sortName
      inducteeClass {
        slug
      }
      relatedSearchTerms {
        searchTerm
      }
    }
  }
`;

export const InducteeInfoFragment = gql`
  ${BaseInducteeInfoFragment}
  fragment InducteeInfo on Inductee {
    ...BaseInducteeInfo
    inducteeMembers {
      name
      signature
      link
    }
    inducteeData {
      inductedBy
      intro {
        headline
        body
      }
    }
  }
`;

